import { Box, Typography } from "@mui/material";

export default function WrapperDate({ date, time }) {
  return (
    <Box>
      <Typography variant="h6" color="text.main">
        {date}
      </Typography>
      <Typography variant="h6" color="text.main">
        {time}
      </Typography>
    </Box>
  );
}
